<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div [ngClass]="{ loading: loading }">
    <app-ion-common-label
      [id]="idLabelSpouse"
      class="document-type-label1"
      labelStyle="display-rg"
      labelDescription="Informações do {{ spouse }}"
      label="Estes dados são uma exigência dos órgãos reguladores,
     necessários para o seu cadastro e protegidos por sigilo bancário."
    >
    </app-ion-common-label>

    <div class="conent-center conent-center--mrt-lg">
      <form [formGroup]="spouseForm" (ngSubmit)="submitForm($event)">
        <div class="content-pad">
          <app-ion-common-input
            [placeholder]="placeholder"
            [error]="error"
            [id]="idComponentName"
            [textError]="textError"
            maxLength="51"
            (textChange)="name = $event; errorMsg()"
            type="text"
            [fieldValue]="name"
            [idLabel]="idLabel"
            [replaceStrTo]="'name'"
            [label]="label"
            [disabled]="!this.edit"
            name="nameSpouse"
            formControlName="nameSpouse"
            labelInputText="true"
            ngDefaultControl
          >
          </app-ion-common-input>
        </div>
        <div>
          <app-ion-common-input
            [placeholder]="placeholderCpf"
            [error]="errorCpf"
            [id]="idComponentCpf"
            [textError]="textErrorCpf"
            maxLength="14"
            (textChange)="cpf = $event; verifyCpf(); setInputTextValue($event)"
            type="tel"
            [fieldValue]="cpf"
            [idLabel]="idLabelCpf"
            [label]="labelCpf"
            [disabled]="!this.edit"
            name="cpfSpouse"
            formControlName="cpfSpouse"
            [replaceStrTo]="'cpf'"
            labelInputText="true"
            ngDefaultControl
            isEnablePaste="true"
          >
          </app-ion-common-input>
        </div>
        <div>
          <app-ion-common-checkbox
            [id]="idCheckboxSpouse"
            [itens]="checkboxList"
            (changeCheckbox)="setSelectCheckbox($event)"
          >
          </app-ion-common-checkbox>
        </div>
      </form>
    </div>
    <app-ion-common-button
      [id]="idButtonSpouse"
      class="hidden"
      [ngClass]="{ hidden: !buttonEnable || name.length === 0 }"
      [loading_verify]="loading"
      [ariaLive]="true"
      [attr.aria-hidden]="!buttonEnable"
      (clickButton)="clickNext()"
      [label]="labelButton"
    ></app-ion-common-button>
  </div>
</ion-content>
